import BaseObject from '../../../../../base/base_object';
import _ from '../../../../../utils/underscore';
import ServiceFactory from "../../../../service_factory";

export class SwedenStructuredLogging extends BaseObject {

    static CLASS = "SwedenStructuredLogging";

    init(params = {}) {
        super.init(params);
        this.serviceFactory = params.serviceFactory || ServiceFactory.create();
    }

    loginMessageSuccess(limitsData) {
        this._getLogger(this._buildLoginSuccessEvent(limitsData)).setTarget('project-sweden-loginMessage').info();
    }

    loginMessageError(errorMessage = '') {
        this._getLogger(this._buildLoginErrorEvent(errorMessage)).setTarget('project-sweden-loginMessage').error();
    }

    realityCheckMessageSuccess(regulationData, sessionTime) {
        this._getLogger({
            event: 'RealityCheckMessage',
            currencyType: this.serviceFactory.currencyService().getCurrency(),
            netLoss: regulationData.TotalNetLoss / 100,
            loggedInTime: sessionTime,
            fullMessage: true
        }).setTarget('project-sweden-realityCheck').info();
    }

    realityCheckMessageError(error, sessionTime) {
        this._getLogger({
            event: 'RealityCheckMessage',
            currencyType: this.serviceFactory.currencyService().getCurrency(),
            loggedInTime: sessionTime,
            fullMessage: false,
            errorDescription: error.ErrorDescription
        }).setTarget('project-sweden-realityCheck').error();
    }

    _getLogger(eventData) {
        return this.serviceFactory.structuredLoggingService().getLogger(eventData);
    }

    _buildLoginSuccessEvent(limitsData) {
        let limits = [],
            currencyService = this.serviceFactory.currencyService();

        if (limitsData.DefinedDepositLimits.length !== 0) {
            limits = limitsData.DefinedDepositLimits.map(limit => {
                return {
                    limitType: limit.Type,
                    limitAmount: _.isNullOrUndefined(limit.Amount) ? 0 : limit.Amount / 100
                }
            })
        }

        return {
            event: 'LoginMessage',
            limits: limits,
            netLoss: _.isNullOrUndefined(limitsData.TotalNetLoss) ? 0 : limitsData.TotalNetLoss / 100,
            currencyType: currencyService.getCurrency(),
            fullMessage: true
        }

    }

    _buildLoginErrorEvent(errorMessage) {
        return {
            event: 'LoginMessage',
            currencyType: this.serviceFactory.currencyService().getCurrency(),
            fullMessage: false,
            errorDescription: errorMessage
        }
    }
}